import '../../assets/common/javascripts/thirdparty/bootstrap/bootstrap.min.js'; // Used for bootstrap popups
import '../../assets/common/javascripts/widgets/SiteMessageWidget.js';
import '../../assets/common/javascripts/widgets/PopupWidgetView.js';
import '../../assets/common/javascripts/shared/toggleExpand.js';
import '../../assets/common/stylesheets/external-crutch.less';
import '../../assets/common/stylesheets/modules/footer/footer.less';
import '../../assets/common/stylesheets/modules/header/index.less';
import '../../assets/global/settings/index.less';
import '../../assets/common/stylesheets/modules/widgets/content-copy-widget.less';
import '../../assets/common/stylesheets/modules/seo/footer-description.less';
import '../../assets/common/stylesheets/modules/widgets/full-width-background-widget.less';
import '../../assets/common/stylesheets/modules/widgets/topCallToAction.less';
import '../../assets/common/stylesheets/modules/howItWorks/all-media-types-info.less';
import '../../assets/global/elements/index.less';
import '../../assets/global/vendor/bootstrap/bootstrap-xl.css';
import '../../assets/videoblocks/stylesheets/components/mixins.less';
import '../global/vendor/tailwind/tailwind.less';
import '../../assets/common/stylesheets/modules/enterprise/ppro-faqs.less';

import AppLoader from '../../assets/react/AppLoader/AppLoader';

import GenericFAQ from '../react/common/components/GenericFAQ';
import PremiereProPluginLandingPageContainer from "../react/Enterprise/containers/PremiereProPluginLandingPageContainer";
import PopUpsContainer from "../react/PopUps/PopUpsContainer";
import AudioContainer from "../react/Audio/containers/AudioContainer";
import NPSModalLoaderContainer from "../react/NPSModalLoader/NPSModalLoaderContainer";
import NavApps from "../react/app/NavApps";

// React entry point

AppLoader.load({
  routes: [],
  auxApps: {
    ...NavApps,
    'pop-up-container': PopUpsContainer,
    'audio-app': AudioContainer,
    'nps-modal': NPSModalLoaderContainer,
    'premiere-pro-plugin-landing-page-container': PremiereProPluginLandingPageContainer,
  },
  propBasedApps: {
    genericFrequentlyAskedQuestions: GenericFAQ
  },
});
